import { render } from "./overview.vue?vue&type=template&id=45bef769&scoped=true"
import script from "./overview.vue?vue&type=script&lang=js"
export * from "./overview.vue?vue&type=script&lang=js"

import "./overview.vue?vue&type=style&index=0&id=45bef769&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45bef769"]])

export default __exports__